module.exports = __webpack_public_path__ + "static/media/404.0db771c4.jpg";